import { render, staticRenderFns } from "./my-collect.vue?vue&type=template&id=4fc27e73&scoped=true&"
import script from "./my-collect.vue?vue&type=script&lang=js&"
export * from "./my-collect.vue?vue&type=script&lang=js&"
import style0 from "./my-collect.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./my-collect.vue?vue&type=style&index=1&id=4fc27e73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc27e73",
  null
  
)

export default component.exports